
import Vue from 'vue'

export default Vue.extend({
  seo: {
    title: 'Twitch Peak Highlight Generator | Aaron Cunliffe',
    description: 'TwitchPeakHighlight is a Python project that generates highlight compilations from video files by detecting audio volume peaks.'
  },
  beforeCreate (): void {
    const plugin = document.createElement('script')
    plugin.setAttribute(
      'src',
      'https://cdn.jsdelivr.net/gh/google/code-prettify@master/loader/run_prettify.js?lang=python&skin=desert'
    )
    plugin.async = true
    document.head.appendChild(plugin)
  }
})
